/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { connect } from "react-redux";

const StepperComponent = (props) => {
  useEffect(() => {}, []);

  const inactiveIcon = (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill="#C4C4C4"
      />
    </svg>
  );

  const activeIcon = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z"
        fill={props.tenantData.color}
        fillOpacity="0.15"
      />
      <path
        d="M9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5Z"
        fill={props.tenantData.color}
      />
    </svg>
  );

  const completedIcon = (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill={props.tenantData.color}
      />
    </svg>
  );

  // ✅ Modern styled() replacement for makeStyles
  const IconWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    height: 22,
    alignItems: "center",

    "&.active": {
      // Add styles if needed when active
    },

    "&.completed": {
      zIndex: 1,
      fontSize: 18,
    },

    "& .circle": {
      backgroundColor: "currentColor",
    },
  }));

  // ✅ Modern styled() connector (already correct in your version)
  const Connector = styled(StepConnector)(({ theme, tenantcolor }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: `${tenantcolor}60`,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: `${tenantcolor}60`,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderTop: "3px dotted",
      borderColor: `${tenantcolor}60`,
    },
  }));

  const icons = (iconProps) => {
    const { active, completed } = iconProps;

    return (
      <IconWrapper
        className={clsx({
          active: active,
          completed: completed,
        })}
      >
        {active ? activeIcon : completed ? completedIcon : inactiveIcon}
      </IconWrapper>
    );
  };

  return (
    <div className="sales-ui-stepper-wrapper">
      <Stepper
        alternativeLabel
        activeStep={props.activeStep}
        connector={<Connector tenantcolor={props.tenantData.color.trim()} />}
      >
        {props.steps.map((label, i) => (
          <Step
            key={label.label}
            onClick={() => i < props.activeStep && props.back(i)}
            style={{ cursor: "pointer" }}
          >
            <StepLabel StepIconComponent={icons}>{label.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => ({
  tenantData: state.auth.tenantData,
});

// Set data to redux store
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StepperComponent);
